import React from 'react';
// import Article from '../../components/article/Article';
import { blog01, blog02, blog03, blog04, blog05 } from './imports';
import './projects.css';
import { Link } from "react-router-dom";


const Projects = () => (
  <div className="pt__blog section__padding" id="projects">
    <div className="pt__blog-heading">
      <h1 className="gradient__text">Projects</h1>
      <h3 className="gradient__text">[ What We Made ]</h3>
    </div>
    <div className="pt__blog-container">

    


    <div className="pt__blog-container_groupA">
    <Link 
    // to={"projectwmci"}>
    to={""}>

    <div className="pt__blog-container_article">
    
    <div className="pt__blog-container_article-image">
      <img src={blog04} alt="blog_image" />
    </div>
    <div className="pt__blog-container_article-content">
      <div>
        <p>World Missionary Church Int</p>
        <h3>Web & Mobile App Development</h3>
      </div>
      <p>Latest</p>
    </div>



    </div>

    </Link>

  </div>

  <div className="pt__blog-container_groupB">
    <Link 
    // to={"projectkharah"}>
    to={""}>

    <div className="pt__blog-container_article">
    
    <div className="pt__blog-container_article-image">
      <img src={blog02} alt="blog_image" />
    </div>
    <div className="pt__blog-container_article-content">
      <div>
        <p>Kharah Living Accents</p>
        <h3>Web Design & Mobile App Development</h3>
      </div>
      <p>Latest</p>
    </div>



    </div>

    </Link>

    <Link 
    // to={"projecthydgeo"}>
    to={""}>

    <div className="pt__blog-container_article">
    
    <div className="pt__blog-container_article-image">
      <img src={blog03} alt="blog_image" />
    </div>
    <div className="pt__blog-container_article-content">
      <div>
        <p>Water Research Institute</p>
        <h3>Web & Mobile App Development</h3>
      </div>
      <p>Latest</p>
    </div>



    </div>

    </Link>

  </div>

  {/* <div className="pt__blog-container_groupB">
        <Article imgUrl={blog02} date="Kharah Living Accents" text="Mobile App & Website Development" />
        <Article imgUrl={blog03} date="Hydgeocom" text="Mobile App Development" />
        
      </div> */}
      
    </div>
  </div>
);

export default Projects;
